var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _mask, _path7, _path8, _path9, _rect7, _path10, _rect8, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSadRobot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 148,
    viewBox: "0 0 149 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.5009,
    y: 4.18941,
    width: 116.885,
    height: 91.7481,
    rx: 14.244,
    fill: "#FDFFF4",
    stroke: "#280003",
    strokeWidth: 8.37882
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7851,
    y: 9.21676,
    width: 104.316,
    height: 81.6935,
    rx: 14.244,
    fill: "#C5D0D4",
    stroke: "#FDFBEC",
    strokeWidth: 8.37882
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.8394,
    y: 19.6904,
    width: 84.2072,
    height: 60.3275,
    rx: 18.4334,
    fill: "#FDFFF2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.214,
    y: 4.21405,
    width: 117.572,
    height: 92.2876,
    rx: 14.3278,
    fill: "#FDFFF4",
    stroke: "#280003",
    strokeWidth: 8.42809
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5353,
    y: 9.27069,
    width: 104.93,
    height: 82.1739,
    rx: 14.3278,
    fill: "#C5D0D4",
    stroke: "#FDFBEC",
    strokeWidth: 8.42809
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 31.6489,
    y: 19.8062,
    width: 84.7023,
    height: 60.6823,
    rx: 18.5418,
    fill: "#FDFFF2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.7191,
    cy: 42.5619,
    r: 8.00669,
    fill: "#280003"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.9095,
    cy: 42.5619,
    r: 8.00669,
    fill: "#280003"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.6689 70.5854C55.6689 69.6669 56.1431 68.7576 57.0641 67.9098C57.9852 67.0621 59.3348 66.2928 61.035 65.6463C62.7352 64.9998 64.7524 64.489 66.97 64.1434C69.1876 63.7977 71.5617 63.6241 73.9552 63.6325C76.3487 63.6409 78.7141 63.8312 80.9148 64.1924C83.1155 64.5535 85.108 65.0784 86.7771 65.7368C88.4462 66.3951 89.7589 67.1737 90.6393 68.0278C91.5197 68.8819 91.9505 69.7944 91.9066 70.7127L88.2649 70.6871C88.2999 69.9534 87.9558 69.2243 87.2523 68.5419C86.5489 67.8595 85.5001 67.2373 84.1665 66.7114C82.8329 66.1854 81.2409 65.766 79.4825 65.4774C77.7242 65.1888 75.8342 65.0368 73.9218 65.0301C72.0095 65.0234 70.1126 65.1621 68.3407 65.4383C66.5689 65.7144 64.9572 66.1226 63.5987 66.6391C62.2402 67.1556 61.1619 67.7703 60.426 68.4476C59.6901 69.125 59.3112 69.8516 59.3112 70.5854L55.6689 70.5854Z",
    fill: "#280003"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1687 25.9483C94.7383 26.7597 94.4972 27.6612 94.4593 28.6008C94.4215 29.5404 94.5877 30.4995 94.9483 31.4227C95.309 32.3458 95.8569 33.2148 96.5605 33.9794C97.2641 34.744 98.1094 35.389 99.0475 35.8773C99.9857 36.3655 100.998 36.6873 102.026 36.824C103.055 36.9608 104.078 36.9097 105.038 36.6739C105.998 36.438 106.876 36.022 107.62 35.4499C108.364 34.8778 108.96 34.1609 109.373 33.3406L106.34 31.7927C106.102 32.2641 105.76 32.6761 105.332 33.005C104.905 33.3338 104.401 33.5728 103.849 33.7084C103.297 33.8439 102.709 33.8733 102.118 33.7947C101.527 33.7161 100.945 33.5312 100.406 33.2506C99.8667 32.97 99.3809 32.5993 98.9766 32.1599C98.5722 31.7204 98.2573 31.221 98.0501 30.6905C97.8428 30.1599 97.7473 29.6087 97.769 29.0687C97.7907 28.5287 97.9293 28.0106 98.1767 27.5443L95.1687 25.9483Z",
    fill: "#280003"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4748 25.9483C49.9053 26.7597 50.1464 27.6612 50.1842 28.6008C50.2221 29.5404 50.0559 30.4995 49.6952 31.4227C49.3346 32.3458 48.7866 33.2148 48.083 33.9794C47.3795 34.744 46.5342 35.389 45.596 35.8773C44.6579 36.3655 43.6454 36.6873 42.6171 36.824C41.5888 36.9608 40.5651 36.9097 39.6051 36.6739C38.6451 36.438 37.7677 36.022 37.0238 35.4499C36.2798 34.8778 35.684 34.1609 35.2707 33.3406L38.3036 31.7927C38.5411 32.2641 38.8835 32.6761 39.3111 33.005C39.7386 33.3338 40.2429 33.5728 40.7946 33.7084C41.3463 33.8439 41.9347 33.8733 42.5256 33.7947C43.1166 33.7161 43.6985 33.5312 44.2376 33.2506C44.7768 32.97 45.2626 32.5993 45.667 32.1599C46.0713 31.7204 46.3862 31.221 46.5935 30.6905C46.8008 30.1599 46.8963 29.6087 46.8745 29.0687C46.8528 28.5287 46.7142 28.0106 46.4668 27.5443L49.4748 25.9483Z",
    fill: "#280003"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.231 99.2891H120.655V159.617C120.655 163.087 117.841 165.901 114.371 165.901H33.5151C30.0445 165.901 27.231 163.087 27.231 159.617V99.2891Z",
    fill: "#280003"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2383 106.621H111.648V155.427C111.648 157.163 110.241 158.569 108.506 158.569H39.3803C37.645 158.569 36.2383 157.163 36.2383 155.427V106.621Z",
    fill: "#C2D1D4",
    stroke: "#FFFEF2",
    strokeWidth: 6.28412
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135.737 33.9341H139.926C143.397 33.9341 146.21 36.7476 146.21 40.2182V63.6789C146.21 67.1495 143.397 69.963 139.926 69.963H135.737V33.9341Z",
    fill: "#FCBD00",
    stroke: "#240002",
    strokeWidth: 4.18941
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-1_34_433",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6631 29.7446H8.37897C3.75148 29.7446 0.000144958 33.496 0.000144958 38.1235V61.5842C0.000144958 66.2117 3.75147 69.963 8.37897 69.963H14.6631V29.7446Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6631 29.7446H8.37897C3.75147 29.7446 0.000144958 33.496 0.000144958 38.1235V61.5842C0.000144958 66.2117 3.75147 69.963 8.37897 69.963H14.6631V29.7446Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6631 29.7446H8.37897C3.75148 29.7446 0.000144958 33.496 0.000144958 38.1235V61.5842C0.000144958 66.2117 3.75147 69.963 8.37897 69.963H14.6631V29.7446Z",
    fill: "#FCBD00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6631 29.7446H8.37897C3.75147 29.7446 0.000144958 33.496 0.000144958 38.1235V61.5842C0.000144958 66.2117 3.75147 69.963 8.37897 69.963H14.6631V29.7446Z",
    fill: "#FCBD00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5684 69.963V29.7446H16.7578V69.963H12.5684ZM14.6631 33.934H8.37897V25.5552H14.6631V33.934ZM4.18956 38.1235V61.5842H-4.18927V38.1235H4.18956ZM8.37897 65.7736H14.6631V74.1524H8.37897V65.7736ZM14.6631 33.934H8.37897V25.5552H14.6631V33.934ZM4.18956 38.1235V61.5842H-4.18927V38.1235H4.18956ZM8.37897 65.7736H14.6631V74.1524H8.37897V65.7736ZM4.18956 61.5842C4.18956 63.8979 6.06522 65.7736 8.37897 65.7736V74.1524C1.43773 74.1524 -4.18927 68.5254 -4.18927 61.5842H4.18956ZM8.37897 33.934C6.06522 33.934 4.18956 35.8097 4.18956 38.1235H-4.18927C-4.18927 31.1822 1.43772 25.5552 8.37897 25.5552V33.934ZM4.18956 61.5842C4.18956 63.8979 6.06522 65.7736 8.37897 65.7736V74.1524C1.43773 74.1524 -4.18927 68.5254 -4.18927 61.5842H4.18956ZM8.37897 33.934C6.06522 33.934 4.18956 35.8097 4.18956 38.1235H-4.18927C-4.18927 31.1822 1.43773 25.5552 8.37897 25.5552V33.934Z",
    fill: "#240002",
    mask: "url(#path-15-inside-1_34_433)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 38.9615,
    y: 165.482,
    width: 30.5827,
    height: 16.3387,
    fill: "#1388D8",
    stroke: "#240002",
    strokeWidth: 5.02729
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.382 183.077V181.401H68.7062H41.894C36.341 181.401 31.8394 185.903 31.8394 191.456V194.389V196.064H33.5151H68.7062H70.382V194.389V183.077Z",
    fill: "#FE5E67",
    stroke: "#240002",
    strokeWidth: 3.35153
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 2.51365,
    y: -2.51365,
    width: 30.5827,
    height: 16.3387,
    transform: "matrix(-1 0 0 1 111.857 167.996)",
    fill: "#1388D8",
    stroke: "#240002",
    strokeWidth: 5.02729
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9232 183.077V181.401H79.599H106.411C111.964 181.401 116.466 185.903 116.466 191.456V194.389V196.064H114.79H79.599H77.9232V194.389V183.077Z",
    fill: "#FE5E67",
    stroke: "#240002",
    strokeWidth: 3.35153
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.907 108.506V106.83H27.2313C15.8939 106.83 6.70314 116.021 6.70314 127.358V131.548V133.223H8.37891H27.2313H28.907V131.548V108.506Z",
    fill: "#BFCED1",
    stroke: "#280003",
    strokeWidth: 3.35153
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2313 133.642H28.907V135.318V142.65C28.907 148.781 23.9365 153.751 17.8051 153.751C11.6737 153.751 6.70314 148.781 6.70314 142.65V135.318V133.642H8.37891H27.2313Z",
    fill: "#FFB901",
    stroke: "#280003",
    strokeWidth: 3.35153
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M117.722 108.506V106.83H119.398C130.736 106.83 139.926 116.021 139.926 127.358V131.548V133.223H138.25H119.398H117.722V131.548V108.506Z",
    fill: "#BFCED1",
    stroke: "#280003",
    strokeWidth: 3.35153
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M119.398 133.642H117.722V135.318V142.65C117.722 148.781 122.693 153.751 128.824 153.751C134.956 153.751 139.926 148.781 139.926 142.65V135.318V133.642H138.25H119.398Z",
    fill: "#FFB901",
    stroke: "#280003",
    strokeWidth: 3.35153
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadRobot);
export default __webpack_public_path__ + "static/media/SadRobot.7593a584ea609db1cb02ed3bb77f987d.svg";
export { ForwardRef as ReactComponent };